import React from 'react'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'

const CheckBox = ({
  checked,
  disabled = false,
  onClick,
  marginTop,
  label = ''
}) => {
  return (
    <FormControlLabel
      control={<Checkbox checked={checked} onChange={() => onClick()} />}
      label={label}
    />
  )
}

export { CheckBox }



// WEBPACK FOOTER //
// ./src/components/common/CheckBox.js